module.exports = __webpack_public_path__ + "static/weddingBackground-e830cff1c53946a008115d5dcb3a673b.jpg";